import React, { useMemo } from 'react';
import moment from 'moment';
import { Alert, Col, Row, Spinner } from 'react-bootstrap';
import AgreementInput from 'components/AgreementInput';
import ButtonSubmitAgreement from 'components/ButtonSubmitAgreement';

interface AgreementProps {
  isViewMode: boolean;
  contract: GQL.IContract;
  form: GQL.IContractOnlineForm;
  loading: boolean;
  data: GQL.IAgreement | null;
  values: any;
  errors: any;
  onChange: (e: React.ChangeEvent) => void;
  onSubmit: () => void;
}

const Agreement = ({
  isViewMode,
  contract,
  form,
  loading,
  data,
  values,
  errors,
  onChange,
  onSubmit,
}: AgreementProps) => {
  const isValid = useMemo<boolean>(
    () =>
      (values?.lastName || '') !== '' &&
      (values?.firstName || '') !== '' &&
      (values?.email || '') !== '' &&
      (values?.mobil || '') !== '' &&
      (values?.city || '') !== '' &&
      (values?.zipCode || '') !== '',
    [values],
  );

  if (loading) {
    return <Spinner animation="border" />;
  }

  if (data) {
    return (
      <Row>
        <Col>
          <Alert variant="primary" className="mb-0">
            Súhlas bol udelený {moment(data.vytv_time).format('D.M. o h:mm')}
          </Alert>
        </Col>
      </Row>
    );
  }

  return (
    <>
      {!isViewMode && (
        <Row>
          <Col>
            <Alert variant="danger" className="mb-0">
              Čaká sa na súhlas so spracovaním osobných údajov manželem / manželkou ...
            </Alert>
          </Col>
        </Row>
      )}
      {isViewMode && (
        <>
          <Row>
            <Col className="mb-3">
              Pre pokračovanie je potrebné, aby ste nám udelili súhlas so spracovaním osobných údajov. Bez tohto súhlasu
              nemôžeme pokračovať.
            </Col>
          </Row>
          <Row>
            <Col>
              <AgreementInput
                name="agreement"
                disabled={!isViewMode}
                checked={!!values.agreement}
                error={errors.agreement}
                onChange={onChange}
              />
            </Col>
          </Row>
          {form.form_id && (
            <Row>
              <Col className="text-right">
                <ButtonSubmitAgreement
                  typ="marketing"
                  source={`Online formulář ${window.location.href}`}
                  data={{
                    contractId: contract.id,
                    clientId: contract.client2?.id || null,
                    lastName: values.lastName,
                    firstName: values.firstName,
                    email: values.email,
                    mobil: values.mobil,
                    city: values.city,
                    zipCode: values.zipCode,
                  }}
                  disabled={!isValid || !values.agreement}
                  onSubmit={onSubmit}
                />
              </Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default Agreement;
